var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 506,
    preserveAspectRatio: "none",
    viewBox: "0 0 435 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.497 10.1661C382.202 16.0348 390.943 21.2096 400.628 21.2096H405C421.569 21.2096 435 34.641 435 51.2096V476C435 492.569 421.569 506 405 506H30C13.4314 506 0 492.569 0 476V51.2096C0 34.6411 13.4315 21.2096 30 21.2096H288.372C298.057 21.2096 306.798 16.0348 314.503 10.1661C322.891 3.77736 333.267 0 344.5 0C355.733 0 366.109 3.77736 374.497 10.1661Z",
    fill: "#EFEFF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.3c1e03effbc62bc174935127a75127e3.svg";
export { ForwardRef as ReactComponent };